import React from 'react';
import { connect } from 'react-redux';
import LinkConstructor from './LinkConstructor';
import { actions } from './LinkConstructor.actions';

const LinkConstructorComponent = connect(
    function mapStateToProps(state) {
        return {
            goalEntries: state.goalEntries.list,
            publisherId: state.user.publisher.id,
            publisherIsReferral: state.user.publisher.referral_publisher
        };
    },
    function mapDispatchToProps(dispatch) {
        return {
            getDataLink: actions.getDataLink,
            getShortUrl: actions.getShortUrl,
            getShortenerDomainList: actions.getShortenerDomainList,
            getQRCode: actions.getQRCode,
            updateShortUrl: actions.updateShortUrl
        };
    }
)(LinkConstructor);

export default LinkConstructorComponent;
